// src/hooks/useGeolocation.js
import { useEffect, useState } from "react";

export default function useGeolocation() {
    const [status, setStatus] = useState("pending"); // pending | granted | denied | error
    const [coords, setCoords] = useState(null);

    useEffect(() => {
        if (!("geolocation" in navigator)) {
            setStatus("error");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                setCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
                setStatus("granted");
            },
            () => setStatus("denied"),
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
    }, []);

    return { status, coords };
}
